<template>
    <div class="w-full">
        <div v-if="error != ''"
        class="mx-auto mn3-alert p-2 my-2 rounded-sm flex flex-row items-center">
            <Icon id="exclamation" class="h-6 w-6 mr-2" />
            <span>{{error}}</span>        
        </div>
        <div class="max-w-screen-lg w-full mx-5 mt-24" v-if="openInBrowser">
            <div v-if="url != ''" class="p-2 cursor-pointer mn3-button mn3-submit rounded-sm block flex" @click="openUrl">
                <Icon class="h-6 w-6 mr-2" id="export" />Please click here to apply for a loan.
            </div>
        </div>
        <div class="max-w-screen-lg w-full" v-else>
            <iframe id="frame" :src="url" :style="frameHeight" class="w-full md:rounded" />
        </div>
    </div>
</template>
<script>
    import { useRouter } from "vue-router"
    import { ref, computed } from 'vue'

    import Icon from '@/components/Icon.vue'

export default{
    components:{
        Icon
    },
    props:{
    },
    computed:{
    },
    async created(){
        document.title = 'Apply for a Loan';

        this.frameHeightUpdate++;
        window.addEventListener("resize", this.windowResize);

        //Check for exiting screen if not enabled
        if(!this.$store.state.fi.origenceLoanappSsoEnabled){
            this.$router.push('/');
        }else{
            this.fetchUrl();
        }
    },
    methods: {
        async fetchUrl(){

            let fail = false;
            let fetched;
            try{
                fetched = await this.$mapi.post("origence-loanapp-sso");
            }catch(e){
                fail = true;
                this.url = '';
                if(e.response && e.response.data && e.response.data.errors){
                  this.error = e.response.data.errors[0].detail;
                }else{
                  this.error = e;
                }
            }

            if(!fail && (fetched.data.data.attributes.restrictedExpires || fetched.data.data.attributes.restrictedMessage)){
                this.url = '';
                this.error = fetched.data.data.attributes.restrictedMessage + '<br /><br /> Restriction expires: ' + this.dateDisplay(fetched.data.data.attributes.restrictedExpires);      
            }else if(!fail){
                this.url = fetched.data.data.attributes.url; 
            }    
            
            //Check if embed is false
            if(fetched.data.data.attributes.embed == false){
                this.openInBrowser = true;
            }

            
        },
        dateDisplay(raw){            
            return new Date(raw + 'Z').toLocaleDateString('en-us', {hour: 'numeric', minute: 'numeric', hour12: true, month: 'short', day:'numeric', timeZoneName: 'short'});
        },
        windowResize(e){
            this.frameHeightUpdate++;
        }
    },
    setup(){
        const url = ref("");
        const error = ref("");
        const openInBrowser = ref(true)

        const frameHeightUpdate = ref(0)
        const frameHeight = computed({          
            get: () => {
                frameHeightUpdate.value++;      
                    
                if(window.innerWidth >= 768)                 
                    return `height: ${window.innerHeight-225}px;`;      
                else 
                    return `height: ${window.innerHeight-132}px;`;           
            }
        });
        function openUrl(){
              window.open(url.value);
        }

        return {
            error,
            url,
            frameHeight,
            frameHeightUpdate,            
            openInBrowser,
            openUrl
        }
    }
}
</script>
